export enum SecuritySettingsPanelMode {
	CLOSED = 'CLOSED',
	ACCESS_CONTROL = 'ACCESS_CONTROL',
	JOIN_REQUIREMENTS = 'JOIN_REQUIREMENTS',
	PREVIEW = 'PREVIEW',
	CSR = 'CSR',
}

export type OpenSecurityMode = Exclude<SecuritySettingsPanelMode, 'CLOSED'>;

export const OPEN_SECURITY_MODES: OpenSecurityMode[] = [
	SecuritySettingsPanelMode.ACCESS_CONTROL,
	SecuritySettingsPanelMode.JOIN_REQUIREMENTS,
	SecuritySettingsPanelMode.PREVIEW,
	SecuritySettingsPanelMode.CSR,
];
